export const ACCURACY_PROGRESS_FILTER = 'ACCURACY_PROGRESS_FILTER';
export const ACCURACY = 'accuracy';
export const PROGRESS = 'progress';



// WEBPACK FOOTER //
// ./components/accuracy-progress-toggle/accuracy-progress-constants.js